module.exports = __webpack_public_path__ + "img/home4.9a2f57e0.svg";